export default "__VITE_ASSET__C4XodJi9__"